<template>
  <div>
    <v-data-table
      v-model="selectedItens"
      :loading="loadingTable"
      :headers="headers"
      :items="reserves"
      sort-by="calories"
      class="elevation-1"
      :page-count="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalStagesPaginate"
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por pagina',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,
      }"
      @click:row="selectItem"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Reservas</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-badge
            class="mr-2"
            :content="bagFilter"
            :value="bagFilter"
            bordered
            color="error"
            overlap
          >
            <v-btn
              class="ml-2"
              rounded
              outlined
              large
              color="primary"
              @click="dialogFilter = true"
            >
              <v-icon>
                {{
                  icons.mdiFilter }}
              </v-icon>Filtros
            </v-btn>
          </v-badge>
          <v-text-field
            v-model="search"
            class="mr-2"
            placeholder="Proucurar ID, Hóspede, Empresa, Solicitante ou Localizador externo"
            :append-icon="icons.mdiMagnify"
            single-line
            label="Localizar"
            outlined
            filled
            rounded
            dense
            hide-details
            @click:append="searchItems()"
            @change="searchItems()"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            rounded
            class="mb-2"
            @click="showDialogNewGuest()"
          >
            <v-icon small>
              {{ icons.mdiPlus }}
            </v-icon>
            Nova Reserva
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.requester="{ item }">
        {{ requester(item) }}
      </template>

      <template v-slot:item.id="{ item }">
        <div class="d-flex align-center">
          <span class="mr-1">{{ item.id }}</span>

          <v-tooltip
            v-if="item.same_group.length > 0"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                v-on="on"
              >
                {{ icons.mdiAccountGroupOutline }}
              </v-icon>
            </template>
            <span>{{ allGroup(item) }}</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:item.guests="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              dark
              v-bind="attrs"
              v-on="on"
            >
              {{ firstGuest(item) }}
            </span>
          </template>
          <span>{{ allGuests(item) }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip
          v-if="item.status == 'confirmed'"
          color="info"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'precheckin'"
          :color="preCheckinComplete(item) ? '#6CBF84' : '#FB8C00'"
          :text-color="preCheckinComplete(item) ? '#1F4D2E' : '#FFFFFF'"
          :title="preCheckinProgress(item)"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'checkin'"
          color="success"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'checkout'"
          color="error"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'canceled'"
          color="secondary"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'pending'"
          color="orange"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'no-show'"
          color="warning"
        >
          {{ reserved(item) }}
        </v-chip>
        <v-chip
          v-if="item.status == 'ical_pending'"
          color="deep-purple"
          dark
        >
          <v-icon
            x-small
            left
          >
            {{ icons.mdiCalendarClock }}
          </v-icon>
          {{ reserved(item) }}
        </v-chip>
      </template>
      <template v-slot:item.reservation_channel.name="{ item }">
        {{ item.reservation_channel ? item.reservation_channel.name : (item.origin || 'Manual') }}
      </template>
      <template v-slot:item.room="{ item }">
        {{ qtdRoom(item) }}
      </template>
      <template v-slot:item.check_in="{ item }">
        {{ formatDate(item.check_in) }}
      </template>
      <template v-slot:item.check_out="{ item }">
        {{ formatDate(item.check_out) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="reserve-actions">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status != 'canceled'"
                icon
                :loading="item.loading_print"
                :disabled="item.loading_print"
                class=""
                color="secondary"
                v-bind="attrs"
                @click="printItem(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiPrinter }}
                </v-icon>
              </v-btn>
            </template>
            <span>Imprimir Voucher</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status === 'precheckin' || item.status === 'checkin' || item.status === 'checkout'"
                icon
                color="teal"
                :loading="item.loading_print_guests"
                :disabled="item.loading_print_guests"
                v-bind="attrs"
                @click="printGuestSheetsItem(item)"
                v-on="on"
              >
                <v-icon>{{ icons.mdiCardAccountDetailsOutline }}</v-icon>
              </v-btn>
            </template>
            <span>Imprimir Fichas dos Hóspedes</span>
          </v-tooltip>

          <v-tooltip
            v-if="item.status == 'ical_pending'"
            top
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="deep-purple"
                v-bind="attrs"
                @click="editItem(item)"
                v-on="on"
              >
                <v-icon>{{ icons.mdiCalendarCheck }}</v-icon>
              </v-btn>
            </template>
            <span>Completar reserva do canal externo</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="primary"
                class=""
                v-bind="attrs"
                @click="editItem(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiPencilOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status == 'pending'"
                icon
                color="success"
                v-bind="attrs"
                :loading="item.loading_confirm"
                :disabled="item.loading_confirm"
                @click="confirmPending(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiCheckCircleOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Confirmar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status != 'canceled'"
                icon
                color="error"
                v-bind="attrs"
                :disabled="!(item.status == 'confirmed' || item.status == 'precheckin')"
                @click="cancelItem(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiCloseCircleOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Cancelar</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status == 'confirmed'"
                icon
                color="success"
                v-bind="attrs"
                @click="payment(item)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiCurrencyUsd }}
                </v-icon>
              </v-btn>
            </template>
            <span>Adiantamento</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="secondary"
                v-bind="attrs"
                @click="showLogDialog(item.id)"
                v-on="on"
              >
                <v-icon>
                  {{ icons.mdiFormatListBulletedSquare }}
                </v-icon>
              </v-btn>
            </template>
            <span>Logs</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status === 'confirmed' || item.status === 'precheckin'"
                icon
                color="teal darken-2"
                :loading="item.loading_fnrh_sync"
                :disabled="item.loading_fnrh_sync"
                v-bind="attrs"
                @click="syncFnrhPreCheckin(item)"
                v-on="on"
              >
                <v-icon>{{ icons.mdiCloudSync }}</v-icon>
              </v-btn>
            </template>
            <span>Sincronizar Pré Check-in FNRH</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:no-data>
        <NoDataTable></NoDataTable>
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>

    <v-card class="mt-2">
      <v-card-subtitle>
        Clique no registro para visualizar a observação:
      </v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            class="text-center"
          >
            <p v-text="selectedItens.length > 0 ? selectedItens[0].obs : ''"></p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- DIALOG FILTRO -->
    <v-dialog
      v-model="dialogFilter"
      width="700"
    >
      <v-card>
        <BarTitleDialog
          title="FILTROS"
          @close="dialogFilter = false"
        />
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="filter.status"
                clearable
                outlined
                label="Status"
                :items="itemsStatus"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-left">
              <v-btn
                text
                color="error"
                x-large
                @click="clearFilter()"
              >
                limpar filtros
              </v-btn>
            </v-col>
            <v-col class="text-right">
              <v-btn
                text
                color="secondary"
                x-large
                @click="dialogFilter = false"
              >
                FECHAR
              </v-btn>
              <v-btn
                color="primary"
                class="ml-2"
                x-large
                @click="confirmFilter()"
              >
                aplicar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG CANCELAR RESERVA -->
    <v-dialog
      v-model="dialogCancel"
      max-width="500px"
    >
      <v-card>
        <BarTitleDialog
          title="Cancelar reserva"
          @close="dialogCancel = false"
        />
        <v-card-title class="text-h5 text-center">
          <v-row no-gutters>
            <v-col>Deseja realmente cancelar ?</v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-textarea
                v-model="justifyCancel"
                outlined
                label="Justificativa"
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                v-model="cancelCashId"
                :loading="loadingOpenedCashs"
                :disabled="loadingOpenedCashs"
                outlined
                label="Caixa"
                :items="cashItems"
                item-value="id"
                item-text="text"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="loadingUserAdmin">
            <v-col class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            color="blue darken-1"
            text
            @click="dialogCancel = false"
          >
            fechar
          </v-btn>
          <v-btn
            large
            color="error"
            :loading="loadingCancel"
            @click="cancelItemConfirm()"
          >
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogReserve
      v-model="dialogNewGuest"
      :in_data="editedItem"
      :title="formTitle"
      @out_data="saveConfirm"
    />

    <DialogLog
      :dialog="dialogLog"
      :title="logTitle"
      :logs="reserve_log"
      @update:dialog="dialogLog = $event"
    />

    <!-- DIALOG RESULTADO FNRH SYNC -->
    <v-dialog
      v-model="dialogFnrhResult"
      max-width="500px"
    >
      <v-card>
        <BarTitleDialog
          title="Sincronização FNRH — Pré Check-in"
          @close="dialogFnrhResult = false"
        />
        <v-card-text class="pt-4">
          <p class="mb-3">
            {{ fnrhResult.message }}
          </p>

          <div v-if="fnrhResult.atualizados.length > 0">
            <p class="font-weight-bold teal--text darken-2">
              Atualizados via gov.br:
            </p>
            <v-chip
              v-for="g in fnrhResult.atualizados"
              :key="g.guest_id"
              class="ma-1"
              color="teal"
              text-color="white"
              small
            >
              {{ g.name }}
            </v-chip>
          </div>

          <div
            v-if="fnrhResult.pendentes.length > 0"
            class="mt-3"
          >
            <p class="font-weight-bold orange--text">
              Ainda pendentes:
            </p>
            <v-chip
              v-for="g in fnrhResult.pendentes"
              :key="g.guest_id"
              class="ma-1"
              color="orange"
              text-color="white"
              small
            >
              {{ g.name }}
            </v-chip>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="dialogFnrhResult = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <MsgDelete v-model="dialogDelete" message="Deseja realmente cancelar ?" @delete-yes="cancelItemConfirm()" /> -->
  </div>
</template>

<script>

// import MsgDelete from '@/components/MsgDelete.vue'
import {
  mdiClose,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiPlus,
  mdiCloseCircleOutline,
  mdiPrinter,
  mdiCurrencyUsd,
  mdiFilter,
  mdiMessageOutline,
  mdiFormatListBulletedSquare,
  mdiAccountGroupOutline,
  mdiCheckCircleOutline,
  mdiCardAccountDetailsOutline,
  mdiCloudSync,
  mdiCalendarClock,
  mdiCalendarCheck,
} from '@mdi/js'
import axios from '@axios'
import { mapActions, mapMutations } from 'vuex'
import NoDataTable from '@/components/NoDataTable.vue'
import DialogReserve from './_components/DialogReserve.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import DialogLog from './_components/DialogLog.vue'

export default {
  components: {
    NoDataTable,
    DialogReserve,
    BarTitleDialog,
    DialogLog,
  },
  data: () => ({
    selectedItens: [],
    loadingUserAdmin: false,
    userAdmin: false,
    cancelCashId: null,
    loadingOpenedCashs: false,
    cashItems: [],
    loadingCancel: false,
    justifyCancel: '',
    dialogCancel: false,
    dialogFilter: false,
    filter: {},
    logTitle: '',
    reserve_log: [],
    socket: null,
    socketHandlers: {},
    dialogLog: false,
    search: '',
    dialogNewGuest: false,
    loadingTable: false,
    totalStagesPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 0,
    dialogDelete: false,
    dialog: false,
    loading: false,
    itemsStatus: [
      { text: 'Checkin', value: 'checkin' },
      { text: 'Checkout', value: 'checkout' },
      { text: 'Cancelado', value: 'canceled' },
      { text: 'Confirmado', value: 'confirmed' },
      { text: 'Pré Check-in', value: 'precheckin' },
      { text: 'Pendente', value: 'pending' },
      { text: 'No-Show', value: 'no-show' },
      { text: 'Pendente Canal Externo', value: 'ical_pending' },
    ],
    headers: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
      },
      {
        text: 'EMPRESA',
        value: 'company.fantasy_name',
      },
      {
        text: 'SOLICITANTE',
        value: 'requester',
      },
      {
        text: 'HÓSPEDE',
        value: 'guests',
      },
      {
        text: 'CATEGORIA',
        value: 'room_category.description',
      },
      {
        text: 'QUARTOS',
        value: 'room',
      },

      {
        text: 'CHECKIN',
        value: 'check_in',
      },
      {
        text: 'CHECKOUT',
        value: 'check_out',
      },
      {
        text: 'CANAL',
        value: 'reservation_channel.name',
      },
      {
        text: 'STATUS',
        value: 'status',
      },

      {
        text: '',
        align: 'end',
        value: 'actions',
        sortable: false,
        width: '240px',
      },
    ],
    reserves: [],
    editedIndex: -1,
    editedItem: {},
    editedDefault: {
      check_in: '',
      check_out: '',
      company_id: '',
      room: [],
      tariff_manual: 'not',
      with_iss: 'not',
    },
    options: {},
    tab: null,
    items: [
      {
        tab: 'One',
        content: 'Tab 1 Content',
      },
      {
        tab: 'Two',
        content: 'Tab 2 Content',
      },
    ],
    icons: {
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiClose,
      mdiCloseCircleOutline,
      mdiPrinter,
      mdiCurrencyUsd,
      mdiFilter,
      mdiMessageOutline,
      mdiFormatListBulletedSquare,
      mdiAccountGroupOutline,
      mdiCheckCircleOutline,
      mdiCardAccountDetailsOutline,
      mdiCloudSync,
      mdiCalendarClock,
      mdiCalendarCheck,
    },
    dialogFnrhResult: false,
    fnrhResult: { atualizados: [], pendentes: [], message: '' },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nova Reserva' : 'Editar Reserva'
    },
    bagFilter() {
      if (this.filter.status == null) {
        delete this.filter.status
      }

      return Object.keys(this.filter).length
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
    options: {
      handler() {
        this.initialize()
      },
    },
  },

  created() {
    this.initialize()

    // carrega o select rooms do dialog reserve
    this.loadRooms()

    // carrega o select categoria de quartos do dialog reserve
    this.loadRoomCategories()

    // carrega o select tariffs
    this.loadTariffs()
    this.setupSocketListeners()
  },
  beforeDestroy() {
    this.teardownSocketListeners()
  },

  methods: {
    ...mapActions('select', ['loadRooms', 'loadRoomCategories', 'loadTariffs']),
    ...mapActions('reserve', [
      'getAll',
      'store',
      'update',
      'printVoucher',
      'printGuestSheets',
      'getReserveItems',
      'cancelReserve',
      'confirmReserve',
      'getOpenedCashs',
      'getUser',
    ]),
    ...mapMutations('checkout', [
      'setCheckout',
      'setStage',
      'clearCheckoutSeparete',
      'setOriginPartialPayment',
      'setRoom',
      'clearCheckout',
    ]),
    ...mapMutations('reserve', ['setGuests', 'setGuestsUnknown']),
    ...mapActions('logs', ['reserveLog']),
    setupSocketListeners() {
      if (!this.$socket) {
        return
      }

      this.socket = this.$socket
      this.socketHandlers = {
        connect: () => console.log('Socket reservas conectado'),
        disconnect: reason => console.log('Socket reservas desconectado', reason),
        reservationEvent: payload => this.handleReservationSocket(payload),
      }

      this.socket.on('connect', this.socketHandlers.connect)
      this.socket.on('disconnect', this.socketHandlers.disconnect)
      this.socket.on('reservations', this.socketHandlers.reservationEvent)
    },
    teardownSocketListeners() {
      if (!this.socket || !this.socketHandlers) {
        return
      }

      this.socket.off('connect', this.socketHandlers.connect)
      this.socket.off('disconnect', this.socketHandlers.disconnect)
      this.socket.off('reservations', this.socketHandlers.reservationEvent)
    },
    handleReservationSocket(payload) {
      if (!payload || !payload.event) {
        return
      }

      if (['reserve-created', 'reserve-updated'].includes(payload.event)) {
        this.initialize()
      }
    },
    initialize() {
      this.loadingTable = true
      this.selectedItens = []
      const { page, itemsPerPage } = this.options

      const payload = {
        itemsPerPage: itemsPerPage || 10,
        page,
        search: this.search,
        filter: this.filter,
      }
      this.getAll(payload)
        .then(response => {
          this.reserves = response.data.data
          this.totalStagesPaginate = response.data.total
          this.numberOfPagesPaginate = response.data.last_page
          this.currentPagePaginate = response.data.current_page
        })
        .finally(() => {
          this.loadingTable = false
        })
    },
    searchItems() {
      this.options = {}
      this.initialize()
    },
    requester(item) {
      if (item.requester == null) {
        if (item.company) {
          return item.company.fantasy_name
        } if (item.guest.length > 0) {
          return item.guest[0].name
        } if (item.guest_unknown.length > 0) {
          return item.guest_unknown[0].name
        }
      } else {
        return item.requester
      }
    },
    clearFilter() {
      this.filter = {}
    },
    confirmFilter() {
      this.initialize()
      this.dialogFilter = false
    },
    firstGuest(item) {
      if (item.guest.length > 0) {
        return item.guest[0].name
      } if (item.guest_unknown.length > 0) {
        return item.guest_unknown[0].name
      }

      return ''
    },

    allGuests(item) {
      const guests = []
      item.guest.forEach(guest => {
        guests.push(guest.name)
      })

      item.guest_unknown.forEach(guest => {
        guests.push(guest.name)
      })

      return guests.join()
    },
    showDialogNewGuest() {
      this.editedItem = {
        ...this.editedDefault,
      }
      this.editedIndex = -1,
      this.setGuests([])
      this.setGuestsUnknown([])
      this.dialogNewGuest = true
    },
    payment(reserve) {
      this.getReserveItems(reserve).then(response => {
        const reserveItems = response.data

        reserveItems.forEach(item => {
          item.origin = 'reserve'
          item.pivot = { quantity: 1 }
          item.sale_price = item.value
          item.description = `HOSPEDAGEM ${this.formatDate(item.date_start)} - ${this.formatDate(item.date_end)}`
        })

        this.clearCheckout()
        this.clearCheckoutSeparete()

        this.setCheckout(reserveItems)
        this.setStage('payment')

        const room = {
          category: reserve.room_category,
          description: 'reserva',
          current_accommodation: reserve,
        }

        this.setRoom(room)

        this.setOriginPartialPayment('reserve')
        this.$router.push({ name: 'checkout' })
      })
    },
    editItem(item) {
      this.editedIndex = this.reserves.indexOf(item)
      this.editedItem = item
      this.setGuests(item.guest)
      this.setGuestsUnknown(item.guest_unknown)

      this.dialogNewGuest = true
    },

    saveConfirm(guest) {
      this.initialize()

      /*
      if (this.editedIndex == -1) {
        this.reserves.push(guest) //adiciona no array
      } else {
        Object.assign(this.reserves[this.editedIndex], guest) // atualiza o guest no array
      }
        */
    },

    cancelItem(item) {
      this.justifyCancel = ''
      this.dialogCancel = true
      this.editedItem = item
      this.userAdmin = false

      // verifica se o usuario tem perfil admin
      this.loadingUserAdmin = true
      this.getUser()
        .then(response => {
          if (response.data) {
            // se tiver perfil administrador
            if (response.data.role_id == 1) {
              this.userAdmin = true
            } else {
              this.userAdmin = false
            }
          }
        })
        .finally(() => {
          this.loadingUserAdmin = false
        })

      // carrega o select de caixas abertos
      this.loadingOpenedCashs = true
      this.getOpenedCashs()
        .then(response => {
          this.cashItems = response.data
        })
        .finally(() => {
          this.loadingOpenedCashs = false
        })
    },

    confirmPending(item) {
      const index = this.reserves.indexOf(item)
      if (index === -1) {
        return
      }
      this.$set(this.reserves[index], 'loading_confirm', true)
      this.confirmReserve({ id: item.id })
        .then(response => {
          Object.assign(this.reserves[index], response.data)
          this.$toast.success('Reserva confirmada com sucesso!')
        })
        .catch(error => {
          const message = error?.response?.data?.message || 'Não foi possível confirmar a reserva.'
          this.$toast.error(message)
        })
        .finally(() => {
          this.$set(this.reserves[index], 'loading_confirm', false)
        })
    },

    cancelItemConfirm() {
      const index = this.reserves.indexOf(this.editedItem)
      const data = {
        id: this.editedItem.id,
        justify_cancel: this.justifyCancel,
        cancel_cash_id: this.cancelCashId,
      }
      this.loadingCancel = true
      this.cancelReserve(data)
        .then(response => {
          Object.assign(this.reserves[index], response.data)
          this.dialogCancel = false
          this.$toast.success('Cancelado com sucesso !')
        })
        .catch()
        .finally(() => {
          this.loadingCancel = false
        })
    },
    qtdRoom(item) {
      if (item.room.length > 0) {
        return item.room.length
      }

      return item.qtd_room
    },
    reserved(item) {
      switch (item.status) {
        case 'confirmed':
          return 'Confirmado'
        case 'precheckin':
          return 'Pré Check-in'
        case 'checkin':
          return 'Checkin'
        case 'checkout':
          return 'Checkout'
        case 'canceled':
          return 'Cancelado'
        case 'pending':
          return 'Pendente'
        case 'no-show':
          return 'No-Show'
        case 'ical_pending':
          return 'Canal Externo'
      }
    },
    preCheckinComplete(item) {
      const total = Number(item.pre_checkin_total_guests) || 0

      return total === 0 || Number(item.pre_checkin_completed_guests) >= total
    },
    preCheckinProgress(item) {
      if (this.preCheckinComplete(item)) return 'Pré-check-in concluído'

      return `Pré-check-in incompleto: ${item.pre_checkin_completed_guests} de ${item.pre_checkin_total_guests} hóspedes`
    },

    printItem(reserve) {
      reserve.loading_print = true
      this.printVoucher(reserve)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'voucher.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {
          console.log(response)
        })
        .finally(() => {
          this.reserves.forEach(item => {
            item.loading_print = false
          })

          // armegagem para força a reação do vue
          const backup = this.reserves
          this.reserves = []
          this.reserves = backup
        })
    },

    printGuestSheetsItem(reserve) {
      const index = this.reserves.indexOf(reserve)
      this.$set(this.reserves, index, { ...reserve, loading_print_guests: true })
      this.printGuestSheets(reserve)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', `fichas_hospedes_${reserve.id}.pdf`)
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(() => {
          this.$toast.error('Erro ao gerar fichas dos hóspedes.')
        })
        .finally(() => {
          this.$set(this.reserves, index, { ...this.reserves[index], loading_print_guests: false })
        })
    },
    syncFnrhPreCheckin(item) {
      const index = this.reserves.indexOf(item)
      this.$set(this.reserves, index, { ...item, loading_fnrh_sync: true })

      axios.post(`reserve/fnrh/sync-precheckin/${item.id}`)
        .then(response => {
          const { data } = response
          this.fnrhResult = {
            atualizados: data.atualizados || [],
            pendentes: data.pendentes || [],
            message: data.message || '',
          }
          this.dialogFnrhResult = true

          if (data.atualizados && data.atualizados.length > 0) {
            this.initialize()
          }
        })
        .catch(() => {
          this.$toast.error('Erro ao sincronizar com a FNRH.')
        })
        .finally(() => {
          this.$set(this.reserves, index, { ...this.reserves[index], loading_fnrh_sync: false })
        })
    },

    closeDelete() {
      this.dialogDelete = false
      this.editedIndex = -1
    },
    formatDate(date) {
      if (date) {
        const result = new Date(date)

        return result.toLocaleDateString('pt-BR', {
          timeZone: 'UTC',
        })
      }
    },
    selectItem(item) {
      this.selectedItens = []
      this.selectedItens.push(item)
    },
    showLogDialog(id) {
      this.reserveLog(id).then(response => {
        this.reserve_log = response.data
      })
      this.logTitle = `Log da reserva ${id}`
      this.dialogLog = true
    },
    allGroup(item) {
      const ids = []
      item.same_group.forEach(id_groups => {
        ids.push(id_groups)
      })

      return ids.join(', ')
    },
  },
}
</script>

<style scoped>
.reserve-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  white-space: nowrap;
}

.reserve-actions .v-btn {
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
}

.card-tab {
  min-height: 420px;
  min-width: 736px;
}

.tool_table_fam {
  height: 50px;
}
</style>
